import { Rating, RatingProps } from '@makyoapp/makyo-tw-ui'

export type CompRatingProps = RatingProps

export const CompRatingCore = Rating
